export interface UtilityValue {
  abs: number, rel: number, date: string
}

export interface UtilityMeterState {
  webComponentValueType: 'abs' | 'rel',
  measuringUnit: string,
  months: UtilityValue[];
}
